import React, { FC, memo } from 'react'
import { Path, Svg } from 'react-native-svg'

import { LegendsSvgProps } from '@legends/types/svg'

const SwapIcon: FC<LegendsSvgProps> = ({ width = 24, height = 24, color = '#54597A', ...rest }) => {
  return (
    <Svg width={width} height={height} viewBox="0 0 24 24" fill="none" {...rest}>
      <Path
        d="M18.3467 12.1758C18.7608 12.1759 19.0967 12.5117 19.0967 12.9258V13.5508C19.0965 16.1739 16.9698 18.3006 14.3467 18.3008H6.53418L8.91113 20.7266C9.20078 21.0224 9.19616 21.4973 8.90039 21.7871C8.60461 22.0765 8.12965 22.0718 7.83984 21.7764L4.21387 18.0762C3.92836 17.7847 3.92863 17.318 4.21387 17.0264L7.83984 13.3262C8.12975 13.0303 8.60454 13.0255 8.90039 13.3154C9.196 13.6054 9.20095 14.0802 8.91113 14.376L6.53516 16.8008H14.3467C16.1414 16.8006 17.5965 15.3455 17.5967 13.5508V12.9258C17.5967 12.5116 17.9325 12.1758 18.3467 12.1758ZM15.1025 2.21387C15.3984 1.92437 15.8733 1.92894 16.1631 2.22461L19.7891 5.9248C20.0746 6.21626 20.0743 6.68299 19.7891 6.97461L16.1631 10.6748C15.8732 10.9707 15.3984 10.9754 15.1025 10.6855C14.8067 10.3956 14.8019 9.92085 15.0918 9.625L17.4678 7.2002H9.65625C7.86143 7.20026 6.40632 8.65537 6.40625 10.4502V11.0752C6.40625 11.4894 6.07041 11.8251 5.65625 11.8252C5.24209 11.8251 4.90625 11.4894 4.90625 11.0752V10.4502C4.90632 7.82694 7.033 5.70026 9.65625 5.7002H17.4688L15.0918 3.27441C14.8019 2.97856 14.8067 2.50376 15.1025 2.21387Z"
        fill={color}
      />
    </Svg>
  )
}

export default memo(SwapIcon)
